'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_navigation_Link_Link = require('../Link/Link.cjs.js');
const components_navigation_InteractiveTag_InteractiveTagContext = require('./InteractiveTagContext.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_r2ilz_1";
const styles = {
	root: root
};

const InteractiveTagWrapper = ({ children, color, href, maxWidth = "none", onClick }) => {
  const sharedProps = {
    className: styles.root,
    "data-color": color,
    onClick,
    style: {
      "--_zds-interactive-tag-wrapper-max-width": maxWidth
    }
  };
  const WrappedChildren = () => {
    if (href) {
      return React__default.default.createElement(components_navigation_Link_Link.Link, Object.assign({}, sharedProps, { color: null, href, weight: null }), children);
    }
    return React__default.default.createElement("button", Object.assign({}, sharedProps, { type: "button", "data-zds": true }), children);
  };
  return React__default.default.createElement(
    components_navigation_InteractiveTag_InteractiveTagContext.InteractiveTagProvider,
    null,
    React__default.default.createElement(components_navigation_InteractiveTag_InteractiveTagContext.InteractiveTagContext.Consumer, null, (context) => {
      return (context === null || context === void 0 ? void 0 : context.isTruncated) ? React__default.default.createElement(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: context.body ? `${context.title}: ${context.body}` : `${context.title}`, shouldCorrectPosition: true }, () => React__default.default.createElement(WrappedChildren, null)) : React__default.default.createElement(WrappedChildren, null);
    })
  );
};

exports.InteractiveTagWrapper = InteractiveTagWrapper;
//# sourceMappingURL=InteractiveTagWrapper.cjs.js.map
